"use client";

import * as React from "react";
import { Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  id: 1,
  quote: "The COHCC Foundation has transformed my business and connected me with invaluable resources. Their mentorship program gave me the confidence to scale operations and reach new markets.",
  author: "Maria Gonzalez",
  role: "Founder, Gonzalez Design Studio",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1214114/img/portrait_maria_gonzalez.png",
  category: "Entrepreneur"
}, {
  id: 2,
  quote: "Their leadership programs helped me grow as a community leader and mentor others. I now have the tools to advocate effectively for my neighborhood and drive real change.",
  author: "Luis Perez",
  role: "Community Organizer, Denver West",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1214114/img/portrait_luis_perez.png",
  category: "Community Leader"
}, {
  id: 3,
  quote: "The scholarship I received allowed me to focus on my engineering degree without the burden of financial stress. I am proud to be the first in my family to graduate college.",
  author: "Sofia Rodriguez",
  role: "Engineering Student, CU Denver",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1214114/img/portrait_sofia_rodriguez.png",
  category: "Student"
}];
export default function VoicesOfProsperity() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="voices-of-prosperity" ref={ref} className={`w-full py-24 bg-background transition-opacity duration-1000 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="mb-16 text-center">
          <h2 className="text-4xl md:text-5xl font-bold font-serif text-primary mb-6">
            Voices of Prosperity
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto font-sans">
            Real stories from the entrepreneurs, leaders, and students shaping
            our community's future.
          </p>
        </div>

        <div className="relative px-4 md:px-12">
          <Carousel opts={{
          align: "start",
          loop: true
        }} className="w-full">
            <CarouselContent>
              {testimonials.map((item, i) => <CarouselItem key={item.id} className="md:basis-1/1 lg:basis-1/1 pl-4">
                  <div data-index={i} className="group relative overflow-hidden rounded-2xl bg-gradient-to-br from-primary/5 to-white border border-primary/10 p-8 md:p-12 lg:p-16 h-full">
                    <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-center">
                      {}
                      <div className="md:col-span-5 lg:col-span-4 order-2 md:order-1">
                        <div className="relative aspect-[3/4] md:aspect-square lg:aspect-[3/4] w-full overflow-hidden rounded-xl shadow-lg">
                          <img src={item.image} alt={item.author} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                          <div className="absolute inset-0 bg-gradient-to-t from-primary/40 to-transparent opacity-60 md:hidden" />
                        </div>
                      </div>

                      {}
                      <div className="md:col-span-7 lg:col-span-8 order-1 md:order-2 flex flex-col justify-center">
                        <Quote className="size-12 text-secondary/40 mb-6 rotate-180" />
                        
                        <blockquote className="mb-8">
                          <p className="text-2xl md:text-3xl lg:text-4xl font-serif italic text-primary leading-tight">
                            "{item.quote}"
                          </p>
                        </blockquote>

                        <div className="space-y-1">
                          <h3 className="text-xl font-bold text-secondary font-sans tracking-wide uppercase">
                            {item.author}
                          </h3>
                          <p className="text-lg text-muted-foreground font-medium">
                            {item.role}
                          </p>
                          <span className="inline-block mt-2 px-3 py-1 bg-primary/5 text-primary text-xs font-bold rounded-full uppercase tracking-wider">
                            {item.category}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            
            <div className="hidden md:block">
              <CarouselPrevious className="left-0 -translate-x-1/2 bg-white border-primary/20 text-primary hover:bg-secondary hover:text-secondary-foreground hover:border-secondary transition-colors size-12" />
              <CarouselNext className="right-0 translate-x-1/2 bg-white border-primary/20 text-primary hover:bg-secondary hover:text-secondary-foreground hover:border-secondary transition-colors size-12" />
            </div>
            
            {}
          </Carousel>
        </div>
      </div>
    </section>;
}